$(document).on('turbo:load', function(){
  $(".js-pin-entry").pincodeInput({inputs:6, characterwidth: 1.25})
});
